import React from "react";
import api from "axios";
import _ from "lodash";
import moment from "moment";

import Loader from "react-loader-spinner";

import CustomerDetails from "./CustomerDetails";

import Form from "./../../components/Form";
import history from "./../../utils/history";

// Styles
import "./activate.scss";

class GiftPackActivate extends React.Component {
  state = {
    isLoading: true,
    isActivating: false,
    showError: false,
    apiError: "",
    activationNumber: this.props.activationNumber,
    barcode: this.props.barcode,
    giftPack: null,
    imageUrl: null,
    description: "",
    selectedPack: null,
    ageVerified: false,
    ageVerifiedError: false,
    activeForm: "",
    customer: {
      title: "",
      title2: "",
      firstName: "",
      firstName2: "",
      lastName: "",
      lastName2: "",
      dateOfBirth: moment.utc("1901-01-01", "YYYY-MM-DD"),
      isDateValid: true,
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      town: "",
      county: "",
      postcode: "",
      country: "GB",
      isCountryValid: true,
      phone: "",
      email: ""
    },
    sender: {
      title: "",
      firstName: "",
      lastName: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      town: "",
      county: "",
      postcode: "",
      country: "GB",
      isCountryValid: true,
      phone: "",
      email: ""
    }
  };

  componentWillMount = () => {
    if (!this.state.activationNumber || !this.state.barcode) {
      history.push("/");
      return;
    }

    api
      .get(`${this.props.config.apiRequest.load}?activationCode=${this.state.activationNumber}&barcode=${this.state.barcode}`)
      .then(response => {
        if (response.data && response.data.code === 1) {
          this.setState({
            giftPack: response.data,
            imageUrl: response.data.imageUrl,
            description: response.data.description
          });

          if (response.data.giftPacks.length === 1) {
            this.setState({
              selectedPack: response.data.giftPacks[0]
            });
          }

          this.props.updateAppState({
            giftPack: response.data
          });
        } else {
          alert(response.data.message);
          history.push("/");
        }
      })
      .catch(() => {
        // Unexpected Error
      })
      .then(() => {
        this.setState({ isLoading: false });
      });
  };

  componentDidMount() {
    document.title = "Register - Gift Pack Activation";
  }

  submit = isValid => {
    // Check Age Restricted
    let ageRestrictError = false;
    if (this.state.selectedPack.ageRestricted && !this.state.ageVerified) {
      this.setState({ ageVerifiedError: true });
      ageRestrictError = true;
    } else {
      this.setState({ ageVerifiedError: false });
    }

    // Validate Title and Country and Date
    const customer = this.state.customer;
    customer.isCountryValid = customer.country ? true : false;
    customer.isDateValid = customer.dateOfBirth ? true : false;
    this.setState({ customer });

    const sender = this.state.sender;
    if (this.state.activeForm === "someone_else") {
      sender.isCountryValid = sender.country ? true : false;
      this.setState({ sender });
    }

    if (
      !isValid ||
      ageRestrictError ||
      !customer.isCountryValid ||
      !customer.isDateValid ||
      (this.state.activeForm === "someone_else" && !sender.isCountryValid)
    ) {
      return;
    }

    const data = {
      activationCode: this.state.activationNumber,
      packId: this.state.selectedPack.packId,
      customer: {
        title: this.state.customer.title,
        title2: this.state.selectedPack.dualMembership ? this.state.customer.title2 : "",
        firstName: this.state.customer.firstName,
        firstName2: this.state.selectedPack.dualMembership ? this.state.customer.firstName2 : "",
        surname: this.state.customer.lastName,
        surname2: this.state.selectedPack.dualMembership ? this.state.customer.lastName2 : "",
        dateOfBirth: this.state.customer.dateOfBirth.utc().format("YYYY-MM-DD"),
        addressLine1: this.state.customer.addressLine1,
        addressLine2: this.state.customer.addressLine2,
        addressLine3: this.state.customer.addressLine3,
        town: this.state.customer.town,
        county: this.state.customer.county,
        postCode: this.state.customer.postcode,
        country: this.state.customer.country.value,
        telephoneNumber: this.state.customer.phone,
        emailAddress: this.state.customer.email,
        dataProtection1: false,
        dataProtection2: false
      },
      fromCustomer:
        this.state.activeForm !== "someone_else"
          ? null
          : {
              title: this.state.sender.title,
              firstName: this.state.sender.firstName,
              surname: this.state.sender.lastName,
              addressLine1: this.state.sender.addressLine1,
              addressLine2: this.state.sender.addressLine2,
              addressLine3: this.state.sender.addressLine3,
              town: this.state.sender.town,
              county: this.state.sender.county,
              postCode: this.state.sender.postcode,
              country: this.state.sender.country.value,
              telephoneNumber: this.state.sender.phone,
              emailAddress: this.state.sender.email,
              dataProtection1: false,
              dataProtection2: false
            },
      duelMembership: this.state.selectedPack.dualMembership,
      ageRestrict: this.state.selectedPack.ageRestricted
    };

    this.setState({ showError: false, apiError: "", isActivating: true });
    this.request = api
      .post(this.props.config.apiRequest.activate, data)
      .then(response => {
        if (response.data.code === 1) {
          // Next State
          history.push("/completed");
        } else {
          if (!response.data || !response.data.message) {
            alert("There was a problem activating your gift pack.");
          }
          this.setState({ showError: true, apiError: response.data.message, isActivating: false });
        }
      })
      .catch(() => {
        // Unexpected Error
        this.setState({ isActivating: false });
      });
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div>
          <div className="row justify-content-center">
            <Loader type="Oval" color="#003087" height="100" width="100" />
          </div>
          <div className="row justify-content-center">
            <span className="loader-message">Loading Gift Pack</span>
          </div>
        </div>
      );
    }

    return (
      <div id="gift-pack-activate-wrapper">
        <h2>Gift Pack Activation</h2>
        <hr className="colorgraph" />

        <div className="d-flex">
          {!this.state.imageUrl && !this.state.description ? (
            ""
          ) : (
            <div id="gift-pack-details">
              <ul>
                <li>
                  <div className="row">
                    <strong className="col-7">Activation Number</strong>
                    <span className="col-5">{this.state.activationNumber}</span>
                  </div>
                </li>
                <li>
                  <div className="row">
                    <strong className="col-7">Barcode</strong>
                    <span className="col-5">{this.state.barcode}</span>
                  </div>
                </li>
              </ul>
              <div>
                {!this.state.imageUrl ? "" : <img src={this.state.imageUrl} className="gift-pack-image mb-2" alt="Gift Pack" />}
                <p>{this.state.description}</p>
              </div>
            </div>
          )}
          <div className="details-form">
            <Form
              ref={c => {
                this.form = c;
              }}
              onSubmit={this.submit}
            >
              {this.packChoiceSelect()}

              <div className="registerTypeFlexBox">
                <div className="form-check">
                  <label className="radio-inline">
                    <input type="radio" name="register_type" value="myself" onChange={this.handleRegisterTypeChange} />{" "}
                    <span className="label-text">REGISTER FOR MYSELF</span>
                  </label>
                </div>
                <div className="form-check">
                  <label className="radio-inline">
                    <input type="radio" name="register_type" value="someone_else" onChange={this.handleRegisterTypeChange} />{" "}
                    <span className="label-text">REGISTER FOR SOMEONE ELSE</span>
                  </label>
                </div>
              </div>
              <hr />
              {this.displayActiveForm()}
            </Form>
          </div>
        </div>
      </div>
    );
  }

  packChoiceSelect = () => {
    return (
      <div>
        {this.state.giftPack.giftPacks.length > 1 ? (
          <div className="form-group">
            <label className="label" style={{ fontSize: 20 + "px" }}>
              Pack Choice: <span className="required">*</span>
            </label>
            <select name="pack_choice" className="form-control" onChange={this.handlePackChoiceChange} required>
              <option value="" selected="selected">
                Please Select
              </option>
              {this.getPackChoices()}
            </select>
          </div>
        ) : (
          ""
        )}
        {this.ageRestrictedField()}
        <hr />
      </div>
    );
  };

  getPackChoices = () => {
    const returnHTML = [];

    _.forEach(this.state.giftPack.giftPacks, pack => {
      returnHTML.push(
        <option key={`packchoice-${pack.packId}`} value={pack.packId}>
          {pack.title}
        </option>
      );
    });

    return returnHTML;
  };

  ageRestrictedField = () => {
    if (this.state.selectedPack && this.state.selectedPack.ageRestricted) {
      return (
        <div className="form-group">
          <div className={this.state.ageVerifiedError ? "form-check form-error" : "form-check"}>
            <label>
              <input type="checkbox" name="ageVerified" value="true" checked={this.state.ageVerified} onChange={this.handleInputChange} required />
              <span className="label-text" style={{ fontSize: "16px" }}>
                I confirm the recipient of this magazine is 18 years of age or older.
              </span>
            </label>
          </div>
        </div>
      );
    }

    return;
  };

  displayActiveForm = () => {
    if (!this.state.activeForm || !this.state.selectedPack) return;

    const detailsRender =
      this.state.activeForm === "myself" ? (
        <div>
          <h4>YOUR DETAILS</h4>
          <CustomerDetails
            formData={this.state.customer}
            isSender={true}
            isReciever={true}
            dualMembership={this.state.selectedPack.dualMembership}
            detailsChanged={this.handleDetailsChange}
          />
          <span className="help-text">
            Valid for UK postal addresses only. An alternative product cannot be chosen or refund given once registration has been completed. This
            does not affect your statutory rights. This pack must be registered within 12 months from date of purchase.
          </span>
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-12 col-md-6">
              <h4>YOUR DETAILS</h4>
              <CustomerDetails
                formData={this.state.sender}
                isSender={true}
                isReciever={false}
                dualMembership={this.state.selectedPack.dualMembership}
                detailsChanged={this.handleDetailsChange}
              />
            </div>
            <div className="col-12 col-md-6">
              <h4>RECIPIENTS DETAILS</h4>
              <CustomerDetails
                formData={this.state.customer}
                isSender={false}
                isReciever={true}
                dualMembership={this.state.selectedPack.dualMembership}
                detailsChanged={this.handleDetailsChange}
              />
            </div>
          </div>
          <span className="help-text">
            Valid for UK postal addresses only. An alternative product cannot be chosen or refund given once registration has been completed. This
            does not affect your statutory rights. This pack must be registered within 12 months from date of purchase.
          </span>
        </div>
      );

    return (
      <div>
        {detailsRender}
        <hr className="colorgraph" />
        {this.state.showError ? <div className="alert alert-error">{this.state.apiError}</div> : ""}
        {!this.state.isActivating ? (
          <button type="submit" className="btn btn-primary btn-block btn-lg">
            ACTIVATE GIFT PACK
          </button>
        ) : (
          <div className="row justify-content-center">
            <Loader type="Oval" color="#003087" height="40" width="40" />
          </div>
        )}
      </div>
    );
  };

  handlePackChoiceChange = e => {
    const giftPack = _.find(this.state.giftPack.giftPacks, i => i.packId === Number(e.target.value));

    if (giftPack) {
      this.setState({ selectedPack: giftPack });
    }
  };

  handleDetailsChange = (type, data) => {
    this.setState({
      [type]: data
    });
  };

  handleInputChange = e => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({
      [e.target.name]: value
    });
  };

  handleRegisterTypeChange = e => {
    this.setState({
      activeForm: e.currentTarget.value
    });
  };
}

export default GiftPackActivate;



// WEBPACK FOOTER //
// ./src/pages/activate/giftPackActivate.jsx